import css from './ViewAlarmSituationSidePageContent.module.css'
import Button from '@/shared/Buttons/Button'
import SeparateLine from '@/shared/Forms/SeparateLine'
import { format } from 'date-fns'
import TrashIcon from '@/assets/icons/trash.svg?react'
import EditIcon from '@/assets/icons/edit.svg?react'
import confirmService from '@/services/ConfirmService/confirm.service.ts'
import cn from '../../../../../../utils/cn.ts'
import { IAlarmSituation } from '@/pages/Processes/AlarmSituations/alarmSituations.types.ts'
import alarmSituationApi from '@/pages/Processes/AlarmSituations/alarmSituations.api.ts'
import alarmSituationsEvents from '@/pages/Processes/AlarmSituations/events/alarmSituations.events.ts'
import AlarmSituationInputFormula from '../../AlarmSituationInputFormula'
import Tag from '@/shared/Tags/Tag'
import equipmentModelsAtom from '@/pages/Equipment/pages/EquipmentModels/equipmentModels.atom.ts'
import { useRecoilValue } from 'recoil'
import { useMemo } from 'react'
import AlarmSituationLevelTag from '@/pages/Processes/AlarmSituations/components/AlarmSituationLevelTag'
import ProtectedContent from '@/services/rights/ProtectedContent'

interface IProps {
  alarmSituation: IAlarmSituation
  onEdit: () => void
  onClose: () => void
}

const ViewAlarmSituationSidePageContent = (props: IProps) => {
  const models = useRecoilValue(equipmentModelsAtom).items

  const filteredModels = useMemo(() => {
    const equipmentModelIds = new Set(props.alarmSituation.equipmentModels)

    return models.filter((model) => equipmentModelIds.has(model.id))
  }, [props.alarmSituation.equipmentModels, models])

  const handleDelete = (alarmSituationId: number) => {
    confirmService.requestConfirm({
      buttonType: 'primary',
      description: 'Вы действительно хотите удалить триггер?',
      onConfirm: () =>
        alarmSituationApi.deleteAlarmSituation(alarmSituationId).then((r) => {
          if (r.status === 'success') {
            alarmSituationsEvents.deleted(r.body.id)
          }
          props.onClose()
        }),
    })
  }

  return (
    <div className="flex-lines gap16" style={{ height: '100%' }}>
      <h4 className="text-heading-4">{props.alarmSituation.name}</h4>
      <SeparateLine />
      <div className={css.wrapperContent}>
        <div className="flex-lines gap16">
          <div className={css.sidePageGrid}>
            <AlarmSituationField
              label="Дата изменения"
              value={format(props.alarmSituation.updatedAt, 'dd.MM.yyyy, HH:mm:ss')}
            />
            <AlarmSituationField
              label="Дата создания"
              value={format(props.alarmSituation.createdAt, 'dd.MM.yyyy, HH:mm:ss')}
            />
            <div className={cn(css.label, 'text-nm', 'text-secondary')}>Тип:</div>
            <div className={cn(css.value, 'text-nm')}>
              <AlarmSituationLevelTag level={props.alarmSituation.level} />
            </div>
            <AlarmSituationField label="Комментарий" value={props.alarmSituation.comment} />
          </div>
          <SeparateLine />

          <h5 className="text-heading-5">Пороговое значение</h5>
          <AlarmSituationInputFormula value={props.alarmSituation.formula} disabled />
          {filteredModels.length !== 0 && (
            <AlarmSituationField
              label="Не вычислять для"
              value={
                <div className="inline-flex-gap gap4 ">
                  {filteredModels.map((model) => (
                    <Tag color="gray" key={model.id}>
                      {model.name}
                    </Tag>
                  ))}
                </div>
              }
            />
          )}
        </div>
      </div>
      <div className={css.actions}>
        <ProtectedContent requiredRight="alarmSituations:update">
          <Button size="default" type="default" text="Редактировать" onClick={props.onEdit} icon={<EditIcon />} />
        </ProtectedContent>
        <ProtectedContent requiredRight="alarmSituations:delete">
          <Button
            size="default"
            type="default"
            text="Удалить"
            onClick={() => handleDelete(props.alarmSituation.id)}
            icon={<TrashIcon />}
          />
        </ProtectedContent>
      </div>
    </div>
  )
}

const AlarmSituationField = ({ label, value }: { label: string; value: string | React.ReactNode }) => {
  return (
    <>
      <div className={cn(css.label, 'text-nm', 'text-secondary')}>{label}:</div>
      <div className={cn(css.value, 'text-nm')}>{value || '-'}</div>
    </>
  )
}

export default ViewAlarmSituationSidePageContent
